import './ColorButton.css'
import React from 'react'
import formatMessage from 'format-message'
import { FRIENDLY_COLORS } from './constants'
import SecondaryToolbarButton from './SecondaryToolbarButton'

export default function ColorButton({
  onCurrentColorChange,
  colorValue,
  isSelected,
  isBackground,
}) {
  const handleClick = (_event) => {
    onCurrentColorChange(colorValue)
  }

  const colorName = FRIENDLY_COLORS[colorValue]
    ? formatMessage(FRIENDLY_COLORS[colorValue])
    : undefined

  let circle = (
    <circle className="ColorButton-main-circle" cx="12.5" cy="12.5" r="8.5" fill={colorValue} />
  )

  if (colorValue === 'transparent') {
    circle = (
      <g stroke="red" strokeWidth="1.5">
        <circle cx="12.5" cy="12.5" r="7" stroke="red" strokeWidth="1.5" fill="white" />
        <line x1="7" y1="7" x2="18" y2="18" />
      </g>
    )
  }

  if (colorValue === '#FFFFFF') {
    circle = (
      <circle
        className="ColorButton-main-circle"
        cx="12.5"
        cy="12.5"
        r="7"
        stroke="#595959"
        fill="#FFFFFF"
      />
    )
  }

  const ariaLabel = isBackground
    ? formatMessage('Annotation markup background color {colorName}', {
        colorName,
      })
    : formatMessage('Annotation markup color {colorName}', {
        colorName,
      })

  return (
    <SecondaryToolbarButton
      title={colorName}
      ariaLabel={ariaLabel}
      onClick={handleClick}
      className="ColorButton"
    >
      {(button) => (
        <div className="ColorButton-inner">
          <svg
            style={{
              width: '25px',
              height: '25px',
            }}
          >
            {(isSelected || button.isHovered || button.isFocused) && (
              <circle
                className="ColorButton-selection-circle"
                cx="12.5"
                cy="12.5"
                r="10.5"
                stroke={button.isHovered ? '#aaa' : '#717F8A'}
                strokeWidth="2.5"
                fill="none"
              />
            )}
            {circle}
          </svg>
        </div>
      )}
    </SecondaryToolbarButton>
  )
}
